/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/upgrade_fleet': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646L31.354 16 28 12.646zM26 26H6V6h20v20z"/><path pid="1" d="M10.5 23.5a2 2 0 002-2 2.01 2.01 0 00-.074-.512l6.788-6.788c.392.187.823.3 1.286.3a3 3 0 003-3v-1l-2 2-2-2 2-2h-1a3 3 0 00-3 3c0 .463.113.895.3 1.286l-6.788 6.788a2.01 2.01 0 00-.512-.074 2 2 0 000 4zm0-3a1 1 0 110 2 1 1 0 110-2z"/>'
  }
})
